import React from 'react';
import ReportDetailContent from './ReportImageSectionFields';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Button,
  Link,
} from '@common-ui/ui';
import { Delete, ModeEdit } from '@mui/icons-material';
import './styles.css';

function DataTable({ data = [], headers = [] }) {
  const tableCellStyle = {
    padding: '8px 5px',
    fontWeight: 'normal',
    textAlign: 'left',
  };

  return (
    <div className="reportsection-component-box">
      <Table style={{ py: 10 }}>
        {headers.length > 0 && (
          <TableHead>
            <TableRow>
              {headers.map((column) => (
                <TableCell style={{ padding: '5px', textAlign: 'left' }} key={column}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              {Object.keys(row).map((key) => (
                <TableCell style={tableCellStyle} key={key}>
                  {row[key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function ImageSet({ imageId, images, disabled, onEdit = null, onDelete = null }) {
  const handleImageEdit = () => {
    onEdit?.(imageId);
  };

  const handleImageDelete = () => {
    onDelete?.(imageId);
  };

  return (
    <div className="reportsection-component-box">
      <div className="reportsection-imageset-container">
        <Typography variant="h4">Thermal Image</Typography>
        {!disabled && (
          <div className="reportsection-imageset-buttonContainer workItem__buttonContainer">
            <Button
              startIcon={<ModeEdit />}
              component={Link}
              onClick={handleImageEdit}
              className="workItem__button workItem__buttonLink"
              underline="none"
            >
              Edit
            </Button>
            <Divider orientation="vertical" variant="middle" />
            <Button startIcon={<Delete />} onClick={handleImageDelete} className="workItem__button">
              Remove
            </Button>
          </div>
        )}
      </div>
      <div className="reportsection-imageset-imageContainer">
        <img src={images[0]} className="reportsection-image" loading="lazy" />
        <img src={images[1]} className="reportsection-image" loading="lazy" />
      </div>
    </div>
  );
}

function Photonotes({ images = [], section = 0 }) {
  if (images.length === 0) return null;
  return (
    <div className="reportsection-component-box">
      {images?.length > 0 && <Typography variant="h4">Photonotes</Typography>}

      <div className="reportsection-photonotes-imageContainer">
        {images?.map((image, index) => (
          <img src={image.src} key={`photonotes_${section}_${index}`} width="327" height="245" />
        ))}
      </div>
    </div>
  );
}

function MarkerTable({ markers = [] }) {
  const headers = ['Marker', 'Temperature', 'ΔT', 'Reference'];

  return (
    <div className="reportsection-component-box">
      <Typography variant="h4">Marker Info</Typography>
      <DataTable data={markers} headers={headers} />
    </div>
  );
}
function InfoTable({ info = [] }) {
  const tableCellStyle = {
    padding: '8px 5px',
    fontWeight: 'normal',
    textAlign: 'left',
  };

  return (
    <div className="reportsection-component-box">
      <Typography variant="h4">Image Info</Typography>
      <Table style={{ py: 10 }}>
        <TableBody>
          {Object.entries(info).map((row, index) => (
            <TableRow key={index}>
              <TableCell style={tableCellStyle}>{row[0]}</TableCell>
              <TableCell style={tableCellStyle}>{row[1]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function Notes({ notes = [], section = 0 }) {
  if (notes.length === 0) return null;

  const notesUserStyle = {
    variant: 'caption',
    sx: {
      fontWeight: 'bold',
    },
  };

  return (
    <div className="reportsection-component-box">
      {notes?.length > 0 && <Typography variant="h4">Notes</Typography>}
      <Table size="small">
        <TableBody>
          {notes?.map((entry, index) => (
            <TableRow key={`note-${section}-${index}`}>
              <TableCell colSpan={1}>
                <div className="reportsection-notes-container">
                  <Typography {...notesUserStyle}>{entry.user}</Typography>
                  <Typography color="grey.700" {...notesUserStyle}>
                    {entry.date}
                  </Typography>
                </div>
                {entry.text}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export { ReportDetailContent, ImageSet, Photonotes, MarkerTable, InfoTable, Notes };
